<template>
  <div class="">
    <!-- ktstate   1  代表 自研 0 代表 购买   学习记录 列表 -->
    <div class="mycurse-top">
      <div class="disFlex curseSear" style="align-items: center;">
        <span class="curseLabel">课程来源</span>
        <span :class="formInline.ktstate==''?'active':''" @click="changeParams('ktstate','')">全部</span>
        <span :class="formInline.ktstate=='0'?'active':''" @click="changeParams('ktstate','0')">已购课程</span>
        <span :class="formInline.ktstate==currentUser.cid?'active':''"
          @click="changeParams('ktstate',currentUser.cid)">自研课程</span>
      </div>
      <div class="disFlex curseSear" style="align-items: center;">
        <span class="curseLabel">学习状态</span>
        <span :class="formInline.kstate==''?'active':''" @click="changeParams('kstate','')">全部</span>
        <span :class="formInline.kstate=='2'?'active':''" @click="changeParams('kstate','2')">已完成</span>
        <span :class="formInline.kstate=='1'?'active':''" @click="changeParams('kstate','1')">未学完</span>
        <span :class="formInline.kstate=='0'?'active':''" @click="changeParams('kstate','0')">未开始</span>
      </div>
      <div class="disFlex curseSear" style="align-items: center;">
        <span class="curseLabel">课程大类</span>
        <span :class="formInline.itype==''?'active':''" @click="changeParams('itype','')">全部</span>

        <span v-for="(item,i) in options" @click="changeParams('itype',item.uniqueCode,i)"
          :class="formInline.itype.indexOf(item.uniqueCode)>=0?'active':''">{{item.text}}</span>

      </div>
      <div class="disFlex curseSear">
        <div class="curseLabel">
          <span class="curseLabel">课程小类</span>
        </div>
        <div class="disFlex" style="flex-wrap: wrap;align-items: center;">
          <span :class="formInline.itype==''||formInline.itype.split('_').length==3?'active':''">全部</span>
          <span v-for="k in childList" @click="changeParams('itype',k.uniqueCode)"
            :class="formInline.itype==k.uniqueCode?'active':''">{{k.text}}</span>
        </div>

      </div>
    </div>

    <div class="mycurse-cont" v-loading="loading">
      <div v-if="tableData.rows.length>0">
        <div v-for="(item,k) in tableData.rows" class="mycurseEvery">
          <div class="mycurseEvery-img"><img :src="wjSrc+item.img" /></div>
          <div class="mycurseEvery-nr">
            <div class="disFlex between" style="width: 100%;">
              <div class="curse-eve-tit"><span class="curse-tit-bq"
                  v-if="item.ktstate=='自研'">自研</span>{{item.productname}}
              </div>
              <div class="curse-eve-btn">
                <!-- <span class="curse-nr-btn1">学习报告</span> -->
                <!-- <span class="curse-nr-btn3" v-if="parseInt(item.percent)>99&&item.isset=='1'"
                  @click="toKaoshi(item.productid,item.ksitype)">开始考试</span> -->

                <span class="curse-nr-btn2" @click="toProduct(item.productid)"
                  v-if="new Date(item.endtime)>=new Date()">继续学习</span>
              </div>
            </div>
            <div class="curse-eve-yxq">
              <span class="curse-yxq-bq">{{item.itypeName}}</span>有效期：{{item.endtime}}
            </div>
            <div class="curse-eve-progress">
              <div :style="'width:'+item.percent+'%'"></div>
            </div>
            <div class="disFlex between">
              <span class="curse-bot-span1">已学课时</span>
              <span class="curse-bot-span2">{{item.percent}}%，{{new Date(item.endtime)>=new Date()?'继续学习':'已到期'}}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-else style="height: 200px;background-color: #fff;text-align: center;">
        <img style="margin: 70px 0 20px;" src="@/assets/images/nodata.png" />
        <div style="font-size: 18px;color: #999999;">暂无数据</div>
      </div>

      <el-pagination background style="margin-top: 10px;text-align: right;" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page="formInline.page" :page-sizes="[10, 20, 50, 100]"
        :page-size="formInline.rows" layout="total, sizes, prev, pager, next, jumper" :total="tableData.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import {
    getItype
  } from '@/assets/js/common.js';
  export default {
    name: 'Mucurse',
    props: ['collapse', 'wjSrc', 'currentUser'],
    data() {
      return {
        options: [],
        childList: [],
        formInline: {
          itype: '',
          kstate: '',
          rows: 10,
          page: 1,
          creator: '',
          ktstate: '',
          nocid: 1
        },
        tableData: {
          rows: [],
          total: 0
        },
        loading: true
      }
    },
    methods: {
      changeParams: function(key, val, i) {
        if (i) {
          this.childList = this.options[i].children;
        }
        this.$set(this.formInline, key, val);
      },
      getList: function(id) {
        this.loading = true;
        this.$axios.get('/kt/ktProductAppy/getlearnownmylistpiag.htm?' + this.$qs.stringify(this.formInline)).then(
          res => {
            var data = res.data;
            this.tableData = data;
            this.loading = false;
          })
      },
      toProduct: function(id) {
        this.$router.push('/ProductDetail?id=' + id);
      },
      toKaoshi: function(id) {
        sessionStorage.setItem('productIdSj', id)
        sessionStorage.setItem('productKsitype', '');
        const {
          href
        } = this.$router.resolve({
          name: 'Kaoshi',
          query: {}
        });
        window.open(href, '_blank');
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      },
    },
    components: {},
    created: function() {
      getItype(this.$axios, ((res) => {
        this.options = res;
        this.childList = res[0].children;
      }));
      this.$set(this.formInline, 'creator', this.currentUser.id);
      // ''
    },
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getList()
        },
        deep: true //true 深度监听
      }
    }
  }
</script>


<style>
  .mycurse-top {
    border: 1px solid #f2f2f2;
    padding: 27px 20px;
  }

  .curseSear {
    margin-bottom: 15px;
  }

  .mycurse-cont {
    padding: 0 20px 50px 20px;
  }

  .curseSear span {
    margin-right: 15px;
    padding: 3px 15px;
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: left;
    color: #333333;
    line-height: 20px;
    cursor: pointer;
  }

  .curseSear span.active {
    background: #e4f3fc;
    color: #0071BA;
    border-radius: 13px;
  }

  .curseSear span.curseLabel {
    height: 20px;
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 500;
    text-align: left;
    color: #333333;
    line-height: 20px;
    /* margin-right: 24px; */
    padding: 3px 0;
    width: 90px;
    display: inline-block;
  }

  .mycurseEvery {
    /* width: 879px; */
    height: 133px;
    opacity: 1;
    border: 1px solid #efefef;
    border-radius: 4px;
    margin: 20px auto 0;
    padding: 20px;
    display: flex;
    align-items: center;
    transition: all 0.3s linear;
  }

  .mycurseEvery:hover {
    border: 1px solid #0071ba;
    border-radius: 4px;
    box-shadow: 0px 2px 4px 0px rgba(0, 113, 186, 0.26);
  }

  .mycurseEvery-img {
    width: 201px;
    height: 121px;
    opacity: 1;
    border-radius: 6px;
  }

  .mycurseEvery-img img {
    width: 201px;
    height: 121px;
    opacity: 1;
    border-radius: 6px;
  }

  .mycurseEvery-nr {
    margin-left: 20px;
    text-align: left;
    width: 100%;
  }

  .curse-eve-tit {
    width: 319px;
    height: 50px;
    opacity: 1;
    font-size: 18px;
    font-family: 'PingFangSC';
    font-weight: 500;
    text-align: left;
    color: #333333;
    line-height: 25px;
  }

  .curse-eve-tit span {
    width: 38px;
    height: 18px;
    opacity: 1;
    background: linear-gradient(126deg, #ff7254 11%, #ff1515 90%);
    border-radius: 6px 6px 6px 0px;
    color: #fff;
    font-size: 13px;
    display: inline-block;
    line-height: 18px;
    text-align: center;
    margin-right: 5px;
  }

  .curse-nr-btn1 {
    width: 86px;
    height: 32px;
    opacity: 1;
    background: #ffffff;
    border: 1px solid #0071ba;
    border-radius: 17px;
    display: inline-block;
    line-height: 32px;
    text-align: center;
    color: #0071BA;
    font-size: 14px;
    font-family: 'PingFangSC';
    margin-right: 20px;
    cursor: pointer;
  }

  .curse-nr-btn2 {
    width: 86px;
    height: 32px;
    opacity: 1;
    background: #0071ba;
    border-radius: 17px;
    display: inline-block;
    line-height: 32px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    font-family: 'PingFangSC';
    cursor: pointer;
  }

  .curse-nr-btn3 {
    width: 86px;
    height: 32px;
    opacity: 1;
    background: #00bc68;
    border-radius: 17px;
    display: inline-block;
    line-height: 32px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    font-family: 'PingFangSC';
    margin-right: 20px;
    cursor: pointer;
  }

  .curse-eve-yxq {
    opacity: 1;
    font-size: 13px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: left;
    color: #9a9a9a;
    line-height: 18px;
    margin: 7px 0;
  }

  .curse-yxq-bq {
    padding: 1px 6px;
    border: 1px solid #f88576;
    border-radius: 5px;
    display: inline-block;
    color: #f88576;
    margin-right: 5px;
  }

  .curse-eve-progress {
    /* width: 638px; */
    height: 10px;
    opacity: 1;
    background: #f2f2f2;
    border-radius: 5px;
    position: relative;
    margin-bottom: 10px;
  }

  .curse-eve-progress div {
    width: 20px;
    height: 10px;
    opacity: 1;
    background: #0071ba;
    border-radius: 5px;
    position: absolute;
  }

  .curse-bot-span1 {
    opacity: 1;
    font-size: 13px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: left;
    color: #9a9a9a;
    line-height: 18px;
  }

  .curse-bot-span2 {
    opacity: 1;
    font-size: 13px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: right;
    color: #0071ba;
    line-height: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/xueyuan/Mucurse.vue